import { Link } from "react-router-dom";
import { Mail, MapPin } from "lucide-react";
import logo from "@/assets/logo.png";

const Footer = () =>
<footer className="border-t border-border/50 bg-card">
    <div className="container py-12 md:py-16">
      <div className="grid gap-8 md:grid-cols-3">
        <div>
          <Link to="/" className="flex items-center gap-2">
            <img alt="Open Hands Healing Foundation" className="h-8 w-8" src="/lovable-uploads/d1b512ad-d3c9-48e8-a4b9-70755e1d3689-sm.png" width="32" height="32" />
            <span className="font-serif text-lg font-semibold">Open Hands Healing Foundation</span>
          </Link>
          <p className="mt-3 text-sm leading-relaxed text-muted-foreground">
            Increasing access to affordable mental health care for individuals and families in need. Serving Northeast Ohio from Twinsburg.
          </p>
        </div>

        <div>
          <h4 className="mb-3 text-sm font-semibold uppercase tracking-wider text-foreground">
            Quick Links
          </h4>
          <ul className="space-y-2 text-sm text-muted-foreground">
            <li><Link to="/about" className="hover:text-primary transition-colors">About Us</Link></li>
            <li><Link to="/programs" className="hover:text-primary transition-colors">Programs & Events</Link></li>
            <li><Link to="/donate" className="hover:text-primary transition-colors">Donate</Link></li>
            <li><Link to="/contact" className="hover:text-primary transition-colors">Contact</Link></li>
            
            <li><Link to="/shop" className="hover:text-primary transition-colors">Shop</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="mb-3 text-sm font-semibold uppercase tracking-wider text-foreground">
            Get in Touch
          </h4>
          <a
          href="mailto:info@openhandshealing.org"
          className="flex items-center gap-2 text-sm text-muted-foreground hover:text-primary transition-colors">

            <Mail className="h-4 w-4" />
            info@openhandshealing.org
          </a>
          <div className="mt-2 flex items-center gap-2 text-sm text-muted-foreground">
            <MapPin className="h-4 w-4" />
            Twinsburg, Ohio
          </div>
        </div>
      </div>

      <div className="mt-10 border-t border-border/50 pt-6">
        <p className="text-center text-xs text-muted-foreground">
          © {new Date().getFullYear()} Open Hands Healing Foundation. All rights reserved.
        </p>
        <p className="mt-1 text-center text-xs text-muted-foreground">
          Open Hands Healing Foundation is a registered 501(c)(3) tax-exempt nonprofit organization. Donations are tax-deductible to the fullest extent allowed by law.
        </p>
        <p className="mt-2 text-center text-xs text-muted-foreground">
          <Link to="/privacy-policy" className="hover:text-primary transition-colors">Privacy Policy</Link>
          {" · "}
          <Link to="/terms" className="hover:text-primary transition-colors">Terms & Conditions</Link>
        </p>
        <p className="mt-2 text-center text-xs">
          <Link to="/admin" className="text-muted-foreground/60 hover:text-primary transition-colors">
            Staff Login
          </Link>
        </p>
      </div>
    </div>
  </footer>;


export default Footer;